export default "__VITE_ASSET__2475b04a__"